import { ProfilePictureComponentController } from './profile-picture.controller';

export const ProfilePictureComponent: ng.IComponentOptions = {
  bindings: {
    profile: '<',
  },
  templateUrl: 'profile/components/profile-picture/profile-picture.html',
  controller: ProfilePictureComponentController,
};
